/* eslint-disable */
export const faqCategories = [
  {
    id: '28924eab-97cc-465a-ba21-f232bb95843f',
    slug: 'most-asked',
    title: 'Más común'
  },
  {
    id: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    slug: 'general-inquiries',
    title: 'Consultas generales'
  },
  {
    id: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
    slug: 'licenses',
    title: 'Comisiones'
  },
  {
    id: '71c34043-d89d-4aca-951d-8606c3943c43',
    slug: 'payments',
    title: 'Pagos'
  }, {
    id: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
    slug: 'support',
    title: 'Soporte'
  }
];
export const faqs = [
  // Most asked
  {
    id: 'f65d517a-6f69-4c88-81f5-416f47405ce1',
    categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
    question: '¿Qué es Casa de Bolsa en Línea BX+?',
    answer: 'Es el servicio por medio del cual podrás operar en el mercado de valores.utilizando una plataforma que te ayudará a cumplir tus necesidadesde operación en tiempo real y con todos los parámetros que exige el mercado bursátil.'
  },
  {
    id: '0fcece82-1691-4b98-a9b9-b63218f9deef',
    categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
    question: '¿Qué significa operar en linea?',
    answer: 'Es el método por el cual se colocan solicitudes de orden de compra oventa de valores, así como depósitos o retiro de efectivo vía Internet, actualizando al método tradicional de colocar órdenes (teléfono. fax ódirectamente con su e ecutivo de cuenta).'
  },
  {
    id: '2e6971cd-49d5-49f1-8cbd-fba5c71e6062',
    categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
    question: '¿Cómo puedo modificar los datos correspondientes a mi(s) contrato(s)?',
    answer: 'Para cambios de dirección, cuenta de e-mail. clave de acceso, cuenta(s) de cheques. beneficiarios o cotitulares, será necesario contactar a tu ejecutivo de cuenta, para que éste a su vez.elabore una carta solicitando la(s) corrección(es) o modificación(es) de dato(s). dicha carta deberá ser firmada por ti y en su caso loscotitulares de la cuenta y remitida para que se actualice la información.'
  },
  {
    id: '974f93b8-336f-4eec-b011-9ddb412ee828',
    categoryId: '28924eab-97cc-465a-ba21-f232bb95843f',
    question: '¿Al realixar consultas u operaciones a travésde CASA DE BOLSA EN LINEA BX+ qué datos de mi contrato despliegan las pantallas correspondientes? ',
    answer: 'A través de CASA DE BOLSA EN LÍNEA BX+, en lo que a información personal se refiere. por tu seguridad. solamente podrás ver tu clave de acceso, para números de contrato o números de cuenta bancarios, nuestro sistema solamente despliega los últimos tres dígitos de los mismos; tratándose de la identidad del titular y/o cotitulares el sistema solamente desplegará las primeras dos letras de cada nombre y apellidos.'
  }, { // General inquiries
    id: '5d877fc7-b881-4527-a6aa-d39d642feb23',
    categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    question: '¿Necesito contar con e-mail o cuenta de correo electrónico?',
    answer: 'Sí,ya que a través de tu cuenta de correo. recibiráscomunicados de importancia como:confirmaciones de operación, NIP provisional. avisos de cancelación de operaciones.confirmación de asignaciones de operaciones en el mercado de capitales, además de que constituye un medio de comunicación rápido y accesible para ponernos en contactocontigo.'
  }, {
    id: '3d1c26c5-1e5e-4eb6-8006-ed6037ed9aca',
    categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    question: '¿Cual esel tiempo de respuesta cuando envío una solicitud de información vía electrónica?',
    answer: 'Recibirás en un plazo máximo de 2 días hábiles respuesta a tus solicitudes de información oasesoría.'
  }, {
    id: '11bd2b9a-85b4-41c9-832c-bd600dfa3a52',
    categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    question: '¿A partir de cuándo puedo realizar consultas u operaciones en mi contrato a través de CASA DE BOLSA EN LÍNEA BX+?',
    answer: 'Anexo al primer correo electrónico que te envíe CASA DE BOLSA VE POR MAS S.A. DE C.V. GRUPO FI NANCIERO VE POR MAS. encontrarás un  NIP provisional. el cual deberás cambiar de forma inmediata a través de nuestra página. utilizando la opción "Cambio de contaseña" y determinar así un  NIP  personalizado; concluido el pasoanterior,el sistema  desplegará el addendum a tu  contrato de intermediación  bursátil, el cual deberás firmar utilizando tu nuevo Nlf Una vez concluido el procedimientoanteriormente citado, usted podrá consultar y realizar operacionesa través de CASA DE BOLSA EN LÍNEA BX +.'
   }, {
    id: 'f55c023a-785e-4f0f-b5b7-47da75224deb',
    categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    question: '¿Cual esel monto mínimo para la apertura de un contrato de inversión?',
    answer: 'El monto mínimo de apertura de un contrato de inversión es $25,000.'
   }, {
    id: 'c577a67d-357a-4b88-96e8-a0ee1fe9162e',
    categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    question: '¿Cómo puedo conocer el estado que guarda mf solicitud de apertura de cuenta?',
    answer: 'A través de tu ejecutivo de cuenta o utilizando nuestra Línea BX+ a los teléfonos: </br> 1102 19 19 en México D.F.o al 0180083 767 627 del Interior de la República </br>  De lunes a jueves de 8 : 30 a 17 : 30 y los viernes de 8 : 30 a 15 : 30 horas.'
  }, {
    id: '1a680c29-7ece-4a80-9709-277ad4da8b4b',
    categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    question: '¿Qué instrumentos de inversión puedo operar en línea?',
    answer: 'Puede solicitar la compra oventa de cualquier tipo de acciones de empresas de alta o mediana bursatilidad que coticen en la B.M.V.y acciones de nuestras Sociedades de Inversión.'
  }, {
    id: 'c49c2216-8bdb-4df0-be25-d5ea1dbb5688',
    categoryId: '395b0d41-b9a8-4cd6-8b5c-f07855e82d62',
    question: 'Si no cuento con Internet ¿Cómo puedo realizar consultas y operaciones en mi contrato de inversión?',
    answer: 'A través de nuestra Línea BX•.o a través de tu ejecutivode cuenta, podrás conocer  la posición de tu contrato, las condiciones del mercado e ingresar ordenes en nuestrosistema. con la misma seguridad y confidencialidad con la que lo harías a través de CASA DE BOLSA EN LÍNEA BX+. A través de Línea BX+ (servicio telefónico Automatizado), podrás consultar en todo momento:</br>• El valor de tu cartera de inversión <br> • Información sobre el índice de la B.M.V.en tiempo real <br> • Precios y rendimientos de nuestras sociedades de inversión '
  },
  // Comisiones
  {
    id: '3ef176fa-6cba-4536-9f43-540c686a4faa',
    categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
    question: '¿Qué comisiones se cobran por operación?',
    answer: 'No se aplica cobro de comisiones en la compra / venta de acciones de sociedades de inversión de deuda.</br> Se aplica una comisión hasta del 1.7% del importe operado por compra y venta de acciones registradas en la B.M.V. ó acciones de sociedadesde inversión común (+IVA).'
   }, {
    id: '7bc6b7b4-7ad8-4cbe-af36-7301642d35fb',
    categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
    question: '¿Qué tipo de solicitudes puedo ha cer para operar acciones de la B.M.V.?',
    answer: "Se pueden solicitar operaciones de compra o venta limitadas, a mercado, y mejor postura limitada (activa o pasiva)."
  }, {
    id: '56c9ed66-a1d2-4803-a160-fba29b826cb4',
    categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
    question: '¿Cómo puedo hacerles llegar mis comentarios, dudas, quejas o sugerencias?',
    answer: 'A través de nuestra página web en la opción Contáctenos, mediante de nuestra Línea BX+ o directamente con tu ejecutivode cuenta;por cualquiera que sea tu elección, se le dará seguimiento personal a cada una de tus inquietudes hasta que hayan quedado resueltas.'
   }, {
    id: '21c1b662-33c8-44d7-9530-91896afeeac7',
    categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
    question: '¿Puedo cancelar mi contrato?',
    answer: 'Sí, la duración del contratoes indefinida.pero en cualquier momento podrás cancelarlo.'
   }, {
    id: '5fa52c90-82be-41ae-96ec-5fc67cf054a4',
    categoryId: 'b388a87f-bfbb-44d0-800c-0ddbce2a5d22',
    question: '¿Se lleva a cabo mi orden de inmediato?',
    answer: "La asignación de una solicitud de compra o venta realizada a través de CASA DE BOLSA EN LÍNEA BX+. se realizará conforme al procedimiento establecido en el sistema de asignación de CASA DE BOLSA VE POR MAS S.A.DE C.V. GRUPO FINANCIERO VE POR MAS (autorizado por la C.N.B.V.).considerando las circunstancias que se presenten como pueden ser.el volumen de las operaciones que se encuentren por realizar en el mercado. el  tipo de orden que se pretenda celebrar, la volatilidad y bursatilidad  de las acciones. posibles afectaciones técnicas en  lossistemas, etc."
  },
  // Payments
  {
    id: '81ac908c-35a2-4705-8d75-539863c35c09',
    categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
    question: '¿Cómo cancelo mi contrato con CASA DE BOLSA VE POR MAS?',
    answer: "Será necesario contactar a tu ejecutivo de cuenta, para que él elabore una carta solicitando la cancelación del contrato, la cual deberás firmar y remitir para que se lleve a cabo el proceso de cancelación del mismo. <br> No obstante, circunstancias de operación normal, la ejecución se realizará en un tiempo máximo de 5 minutos."
  }, {
    id: 'b6d8909f-f36d-4885-8848-46b8230d4476',
    categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
    question: '¿Qué instrumentos de inversión puedo operar en línea?',
    answer: 'Laboris ea nisi commodo nulla cillum consequat consectetur nisi velit adipisicing minim nulla culpa amet quis sit duis id id aliqua aute exercitation non reprehenderit aliquip enim eiusmod eu irure.\n\nNon irure consectetur sunt cillum do adipisicing excepteur labore proident ut officia dolor fugiat velit sint consectetur cillum qui amet enim anim mollit laboris consectetur non do laboris lorem aliqua.'
  }, {
    id: '9496235d-4d0c-430b-817e-1cba96404f95',
    categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
    question: '¿Cómo sé que la Casa de Bolsa recibió mi solicitud?',
    answer: 'A toda operación realizada a través de CASA DE BOLSA EN LÍNEA BX+. le corresponderá un número de folio único. el cual estará impresoen el comprobante de operación generado por  nuestro sistema al concluir cualquiera  de las operaciones que realices.'
  }, {
    id: '7fde17e6-4ac1-47dd-a363-2f4f14dcf76a',
    categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
    question: '¿Cómo sé que mi orden será procesada como yo indiqué?',
    answer: "Toda orden.antes de ser enviada. es validada por nuestro sistema. desplegando una pantalla de confirmación de Operación en ese momento podrás realizar cambios si así lo deseas, para entonces proceder al envío de la orden. Una vez confirmada se te proporcionará un número de folio único que indica que recibimos tu orden con las condiciones que especificaste."
  }, {
    id: '90a3ed58-e13b-40cf-9219-f933bf9c9b8f',
    categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
question : '¿Por qué en mi posición existe efectivo que no puedo retirar??',
 answer : 'Porque es efectivoque se guarda para liquidar las operaciones de compra que tenga pendien tes.Se podrá disponer de este montohasta el día de la liquidación y servirá para cubrir el importe antes mencionado.'
   }, {
    id: '153376ed-691f-4dfd-ae99-e204a49edc44',
    categoryId: '71c34043-d89d-4aca-951d-8606c3943c43',
    question: '¿Ingresar una orden quiere decir que ya fue ejecutada?',
    answer: 'No, recibirás confirmación de ejecución de órdenes a travésde tu correo electrónico.'
  },
  // Support
  {
    id: '4e7ce72f-863a-451f-9160-cbd4fbbc4c3d',
    categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
    question: '¿Se pueden cancelar o modificar órdenes?',
    answer: "Sí, toda orden es susceptible de cancelación y/o modificación, siempre y cuando ésta no haya sido satisfecha por el volumen total o parcial de la solicitud de modificación/cancelación. <br> En casode existir asignación previa, el sistema sólo permitirá la cancelación o modificación del volumen restante."
  }, {
    id: '0795a74f-7a84-4edf-8d66-296cdef70003',
    categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
    question: '¿Puedo reallzar operacionesa travésde CASA DE BOLSA EN LÍNEA BX+ sin tener valoreso efectivo en mi contrato de Inversión?',
    answer: "Tratándose de operaciones de compra de Sociedades de Inversión, podrás realizar las mismas una vez que hayas reportado el importe que cubrirá la operación a través de la opción Avisode depósito,sin embargo,si el depósito reportado no se ha efectuado a las 13:20 horas, se procederá a su cancelación y de toda operación realizada tomando como base el importe a que se hace referencia. <br> Para operaciones de compra en el mercado de capitales,aunque la liquidación se realiza 48 horas después de haberse realizado la asignación correspondiente, el sistema no permitirá el envío de solicitudes. si en tu contrato de inversión no existe efectivo disponible o ventas de valores (incluyendo Sociedadesde Inversión).que se liquiden en la misma fecha en que se liquida la operación de referencia."
  }, {
    id: '05532574-c102-4228-89a8-55fff32ec6fc',
    categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
question : '¿Cómo puedo hacer mis retirosy depósitos ? ',
answer : "Los depósitos a tu contratode inversión podrán ser efectuados a través de Internet ó mediante depósitoen sucursal bancaria, dependiendo del(los) banco(s) en los que tengas concentrados tus recursos."
   }, {
    id: 'b3917466-aa51-4293-9d5b-120b0ce6635c',
    categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
question : '¿Cómo puedo conocer el importe disponible para retiro en mi contrato?',
answer : 'A través de la opción Consulta de Saldos,el sistema desplegará el importe de efectivo disponible.el cual en casode requerirlo podrás retirar.'
   }, {
    id: '2f2fb472-24d4-4a00-aa80-d513fa6c059c',
    categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
question : '¿Qué pasa con mi dinero cuando no está invertido en acciones. o no lo inverti a través de CASA DE BOLSA EN LiNEA BX+ omi ejecutivo de cuenta ?',
answer : 'Todos los días se compra el fondo BX+ CP por el total de dinero en efectivo (que no se encuentre comprometido con alguna obligación) que hay en el contrato.'
  }, {
    id: '2fffd148-7644-466d-8737-7dde88c54154',
    categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
question : '¿A través de CASA DE BOLSA EN LÍNEA BX+ tengo acceso a información que me permita tomar decisiones?',
 answer : "Sí, podrás consultar la sección de análisis (Boletín Di ario, Histórico de Noticias, Reporte Semanal, Agend a Mensual) de la página de Internet, que te proporcionará elementos y bases para una toma de decisión en cuanto a la adquisición o venta de instrumentos de inversión."
   }, {
    id: '24a1034e-b4d6-4a86-a1ea-90516e87e810',
    categoryId: 'bea49ee0-26da-46ad-97be-116cd7ab416d',
question : '¿Algún instrumento garantíza cierto rendimiento?',
answer : "No, por su naturaleza hay instrumentos que presentan más riesgos que otros. pero ninguno puede garantizar una tasa predeterminada."
  }
];
export const guideCategories = [
  {
    id: '0ee72de7-49c0-4880-9e89-b72a4edd6a81',
    slug: 'getting-started',
    title: 'Getting Started'
  },
  {
    id: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'projects',
    title: 'Projects'
  },
  {
    id: 'c88a1f54-360a-4b9b-a54b-2f92b7a1f63b',
    slug: 'settings',
    title: 'Glosario'
  },
  {
    id: '7b25b38c-1ab3-4474-8569-65b3ea232add',
    slug: 'payments',
    title: 'Payments'
  }, {
    id: '41fdf071-aec4-49de-9dd4-b4f746596928',
    slug: 'your-account',
    title: 'Your Account'
  }
];
export const guides = [
  // Getting started
  {
    id: 'a008ffa3-7b3f-43be-8a8f-dbf5272ed2dd',
    categoryId: '0ee72de7-49c0-4880-9e89-b72a4edd6a81',
    slug: 'what-is-this-app',
    title: 'What is this app?',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  },
  {
    id: '7643d388-12ab-4025-a2f1-5045ac7b1c4c',
    categoryId: '0ee72de7-49c0-4880-9e89-b72a4edd6a81',
    slug: 'start-using-the-app',
    title: 'Start using the app',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  },
  {
    id: '1fecee67-c4b4-413a-b0f2-949dcab73249',
    categoryId: '0ee72de7-49c0-4880-9e89-b72a4edd6a81',
    slug: 'signing-in-to-the-dashboard',
    title: 'Signing in to the dashboard',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  },
  {
    id: 'd2e2ea8f-5298-4ba2-898b-afc60c064bba',
    categoryId: '0ee72de7-49c0-4880-9e89-b72a4edd6a81',
    slug: 'navigating-within-the-app',
    title: 'Navigating within the app',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  },
  // Projects
  {
    id: 'f2592886-11b8-4b56-baab-96802c2ed93e',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'creating-a-project',
    title: 'Creating a project',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '9ec3f4b9-a355-4f57-9e93-efa8611cc1c9',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'renaming-a-project',
    title: 'Renaming a project',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '1bc6e7f9-b046-4f4f-9b18-741c9d5429f6',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'displaying-a-project',
    title: 'Displaying a project',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: 'a005d5f1-938d-45c5-8ed4-d0cf8d02e533',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'deleting-a-project',
    title: 'Deleting a project',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '43837279-dce2-4dc0-beac-30b5ba829f14',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'changing-the-visibility-of-a-project',
    title: 'Changing the visibility of a project',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '4cf5a435-eaa0-463c-8d2b-efde193c7fb3',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'adding-media-to-a-project',
    title: 'Adding media to a project',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: 'cd3fb87e-e138-4721-9e29-a5c751bfd949',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'removing-a-media-from-a-project',
    title: 'Removing a media from a project',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: 'f26205c6-882e-4713-b067-c73758b45551',
    categoryId: '07b8421f-20bf-45b6-90ee-169ebe3a5bcc',
    slug: 'cropping-a-media',
    title: 'Cropping a media',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  },
  // Settings
  {
    id: '1cbdeaeb-bbf1-4d04-b43d-f37b55e6a229',
    categoryId: 'c88a1f54-360a-4b9b-a54b-2f92b7a1f63b',
    slug: 'general-settings',
    title: 'General settings',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '98de7d4a-2ca2-4d47-bbe6-083ed26467db',
    categoryId: 'c88a1f54-360a-4b9b-a54b-2f92b7a1f63b',
    slug: 'project-settings',
    title: 'Project settings',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '145f497c-1fdb-47b5-a6c1-31f856403571',
    categoryId: 'c88a1f54-360a-4b9b-a54b-2f92b7a1f63b',
    slug: 'media-settings',
    title: 'Media settings',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '0a007f59-a5ea-4875-991d-f22d6fd69898',
    categoryId: 'c88a1f54-360a-4b9b-a54b-2f92b7a1f63b',
    slug: 'domain-settings',
    title: 'Domain settings',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '4707c8eb-31f9-415c-bd07-86f226c75feb',
    categoryId: 'c88a1f54-360a-4b9b-a54b-2f92b7a1f63b',
    slug: 'privacy-settings',
    title: 'Privacy settings',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  },
  // Payments
  {
    id: 'c771bf0a-1e0c-4b6d-af7e-189e10cc6fb8',
    categoryId: '7b25b38c-1ab3-4474-8569-65b3ea232add',
    slug: 'subscriptions',
    title: 'Subscriptions',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '3d7150d2-feb3-4f20-bd3f-8e525cef77a4',
    categoryId: '7b25b38c-1ab3-4474-8569-65b3ea232add',
    slug: 'discounts',
    title: 'Discounts',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '79239bc4-4fb5-428b-b30d-62c5289b061d',
    categoryId: '7b25b38c-1ab3-4474-8569-65b3ea232add',
    slug: 'payment-methods',
    title: 'Payment methods',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '8d68c5e6-5404-450c-9d5f-d9800c164041',
    categoryId: '7b25b38c-1ab3-4474-8569-65b3ea232add',
    slug: 'overdue-payments',
    title: 'Overdue payments',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  },
  // Your account
  {
    id: '60df0d4c-dda1-439c-bd44-179c57a7597d',
    categoryId: '41fdf071-aec4-49de-9dd4-b4f746596928',
    slug: 'changing-your-username',
    title: 'Changing your username',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '0a9c3321-1db3-42bc-92b6-7e257368123e',
    categoryId: '41fdf071-aec4-49de-9dd4-b4f746596928',
    slug: 'changing-your-email',
    title: 'Changing your email',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '80ba5106-5f9c-4ed7-b8f3-8544035e3095',
    categoryId: '41fdf071-aec4-49de-9dd4-b4f746596928',
    slug: 'changing-your-password',
    title: 'Changing your password',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: 'db2e97a6-d657-4e9d-9b6c-5f213ea3301c',
    categoryId: '41fdf071-aec4-49de-9dd4-b4f746596928',
    slug: 'closing-your-account',
    title: 'Closing your account',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: '3374c887-2fb7-4223-9f40-7f2cbbf76795',
    categoryId: '41fdf071-aec4-49de-9dd4-b4f746596928',
    slug: 'account-limits',
    title: 'Account limits',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }, {
    id: 'cc65f92a-7d46-4557-b15b-6f8f59a60576',
    categoryId: '41fdf071-aec4-49de-9dd4-b4f746596928',
    slug: 'two-factor-authentication',
    title: 'Two factor authentication',
    subtitle: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt'
  }
];
 // Since we only have one content for the demo, we will
// use the following mock-api on every request for every guide.
export const guideContent = `
<h2>Header Level 2</h2>
 <p>
    <strong>Pellentesque habitant morbi tristique</strong> senectus et netus et malesuada fames ac turpis egestas. Vestibulum tortor quam, feugiat vitae, ultricies eget, tempor sit
    amet, ante. Donec eu libero sit amet quam egestas semper. <em>Aenean ultricies mi vitae est.</em> Mauris placerat eleifend leo. Quisque sit amet est et sapien ullamcorper
    pharetra. Vestibulum erat wisi, condimentum sed, <code>commodo vitae</code>, ornare sit amet, wisi. Aenean fermentum, elit eget tincidunt condimentum, eros ipsum rutrum orci,
    sagittis tempus lacus enim ac dui. <a href="#"
                                          class="link">Donec non enim</a>
    in turpis pulvinar facilisis. Ut felis.
</p>
 <p>
    Orci varius natoque penatibus et magnis dis <em>parturient montes</em>, nascetur ridiculus mus. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos
    himenaeos. Curabitur vitae sagittis odio. <mark>Suspendisse</mark> ullamcorper nunc non pellentesque laoreet. Curabitur eu tortor id quam pretium mattis. Proin ut quam velit.
</p>
 <h3>Header Level 3</h3>
 <img src="assets/images/pages/help-center/image-1.jpg">
<p class="text-secondary">
    <em>Nullam sagittis nulla in diam finibus, sed pharetra velit vestibulum. Suspendisse euismod in urna eu posuere.</em>
</p>
 <h4>Header Level 4</h4>
 <blockquote>
    <p>
        Blockquote. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus magna. Cras in mi at felis aliquet congue. Ut a est eget ligula molestie gravida. Curabitur
        massa. Donec eleifend, libero at sagittis mollis, tellus est malesuada tellus, at luctus turpis elit sit amet quam. Vivamus pretium ornare est.
    </p>
    <footer>
        Brian Hughes
    </footer>
</blockquote>
 <ol>
    <li>Ordered list</li>
    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</li>
    <li>Aliquam tincidunt mauris eu risus.</li>
</ol>
 <h5>Header Level 5</h5>
 <ul>
    <li>Unordered list</li>
    <li>Lorem ipsum dolor sit amet, consectetuer adipiscing elit.</li>
    <li>Aliquam tincidunt mauris eu risus.</li>
</ul>
 <pre><code>#header h1 a {
    display: block;
    width: 300px;
    height: 80px;
}</code></pre>
 <h6>Header Level 6</h6>
 <dl>
    <dt>Definition list</dt>
    <dd>
        Quisque sit amet risus enim. Aliquam sit amet interdum justo, at ultricies sapien. Suspendisse et semper urna, in gravida eros. Quisque id nibh iaculis, euismod urna sed,
        egestas nisi. Donec eros metus, congue a imperdiet feugiat, sagittis nec ipsum. Quisque dapibus mollis felis non tristique.
    </dd>
     <dt>Definition list</dt>
    <dd>
        Ut auctor, metus sed dapibus tempus, urna diam auctor odio, in malesuada odio risus vitae nisi. Etiam blandit ante urna, vitae placerat massa mollis in. Duis nec urna ac
        purus semper dictum ut eget justo. Aenean non sagittis augue. Sed venenatis rhoncus enim eget ornare. Donec viverra sed felis at venenatis. Mauris aliquam fringilla nulla,
        sit amet congue felis dignissim at.
    </dd>
</dl>`;
